import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Cliente = () => {
  const navigate = useNavigate();

  return (
    <div
      className="relative min-h-screen bg-cover bg-center flex items-center justify-center"
      style={{
        backgroundImage: "url('/fundo-cliente.jpg')", // imagem de fundo
      }}
    >
      {/* Overlay escuro */}
      <div className="absolute inset-0 bg-black bg-opacity-60 backdrop-blur-sm z-0" />

      {/* Conteúdo central */}
      <div className="relative z-10 text-center px-6">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white drop-shadow-md font-serif mb-4">
          Bem-vindo caro cliente
        </h1>
        <p className="text-base sm:text-lg md:text-xl text-[#caa874] font-medium max-w-xl mx-auto drop-shadow-sm">
          Nosso ambiente ainda está em desenvolvimento. <br />
          Em breve teremos novidades! Aguardem. 🚧
        </p>
      </div>

      {/* Setinha de voltar */}
      <button
        onClick={() => navigate("/home")}
        className="absolute bottom-10 left-10 text-white text-4xl hover:text-yellow-400 transition duration-300 z-10"
        title="Voltar para Home"
      >
        <FaArrowLeft />
      </button>
    </div>
  );
};

export default Cliente;
